import React, { useState } from 'react';
import './CustomButton.scss';
import ContentCard from '../EtapQuatreJ/ContentCard';

const CustomButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const handleCloseModal = (e) => {
    // Prevents the modal content's click from closing the modal
    if (e.target === e.currentTarget) {
      setIsModalOpen(false);
    }
  };

  return (
    <div className="app-container">
      <div className="custom-button-container">
        <button className="custom-button" onClick={handleButtonClick}>
        Order now
        </button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content">
            <ContentCard />           
            
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomButton;
